<div class="mensaje_finalizado_container">
  <p>La operación termino correctamente!</p>
  <mat-icon>done</mat-icon>
</div>

